import type { CardApi } from "../../api/CardApi";
import type { CardEditCardRequest } from "../../generated/dto/CardEditCardRequest";
import type { CardFetchOptions } from "../../generated/dto/CardFetchOptions";
import type { CardIssueFreeCardRequest } from "../../generated/dto/CardIssueFreeCardRequest";
import type { CardMember } from "../../generated/dto/CardMember";
import type { CardMemberFetchOptions } from "../../generated/dto/CardMemberFetchOptions";
import type { CardMemberSearchResult } from "../../generated/dto/CardMemberSearchResult";
import type { CardSearchParams } from "../../generated/dto/CardSearchParams";
import type { CardStaff } from "../../generated/dto/CardStaff";
import type { CardStaffSearchResult } from "../../generated/dto/CardStaffSearchResult";
import type { PersonFetchOptions } from "../../generated/dto/PersonFetchOptions";
import type { PersonStaff } from "../../generated/dto/PersonStaff";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class CardFrontendService {
  constructor(private readonly api: CardApi) {}
  async getCardMember(id: number, options?: CardMemberFetchOptions): Promise<CardMember> {
    return this.api.getCardMember(id, options)
  }
  async getCardStaff(id: number, options?: CardFetchOptions): Promise<CardStaff> {
    return this.api.getCardStaff(id, options)
  }
  async searchCardMember(params: CardSearchParams, page: number, perPage: number): Promise<PaginationResult<CardMemberSearchResult>> {
    return this.api.searchCardMember(params, page, perPage)
  }
  async searchCardStaff(params: CardSearchParams, page: number, perPage: number): Promise<PaginationResult<CardStaffSearchResult>> {
    return this.api.searchCardStaff(params, page, perPage)
  }
  async searchCardMemberFull(params: CardSearchParams, page: number, perPage: number, options?: CardMemberFetchOptions): Promise<PaginationResult<CardMember>> {
    return this.api.searchCardMemberFull(params, page, perPage, options)
  }
  async searchCardStaffFull(params: CardSearchParams, page: number, perPage: number, options?: CardFetchOptions): Promise<PaginationResult<CardStaff>> {
    return this.api.searchCardStaffFull(params, page, perPage, options)
  }
  async getCardStaffPersonId(id: number, options?: PersonFetchOptions): Promise<PersonStaff | null> {
    return this.api.getCardStaffPersonId(id, options)
  }
  async editCardStaff(request: CardEditCardRequest): Promise<CardStaff> {
    return this.api.editCardStaff(request)
  }
  async issueFreeCardStaff(request: CardIssueFreeCardRequest): Promise<CardStaff> {
    return this.api.issueFreeCardStaff(request)
  }
}
